export default "__VITE_ASSET__41e37c28__"